module.exports = __webpack_public_path__ + "static/media/SHSProdIcons_GameSystem.9d42ad90.svg";


//////////////////
// WEBPACK FOOTER
// ./packages/smart-home-support/pages/homepage/resources/SHSProdIcons_GameSystem.svg
// module id = 3542
// module chunks = 0